import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest } from "../Common/request";
import { UserRole } from "../Common/types";

export type CompleteProfileRequest = {
    userId: number;
    firstName: string;
    lastName: string;
    role: UserRole | null;
};

export type CompleteProfileResponse = {
    redirectUrl: string;
};

export type CompetitorOnboardingContactInfo = {
    phone: string;
    marketingOverPhone: boolean;
    marketingOverEmail: boolean;
};

export type UserProfile = {
    firstName: string | null;
    lastName: string | null;
    email: string;
    phone: string | null;
};

export type UserPreferences = {
    marketingOverPhone: boolean;
    marketingOverEmail: boolean;
    explicitlySaved: boolean;
    paymentConfirmedNotification: boolean;
};

export default {
    getUserProfile(userId: number): Promise<UserProfile> {
        return usePromisedRequest<UserProfile>({
            url: `/api/users/${userId}`,
            method: "get",
            json: true,
        }).then(resolveWithBody("Could not fetch user profile."));
    },
    updateUserProfile(userId, payload) {
        return usePromisedRequest({
            url: `/api/users/${userId}`,
            method: "put",
            json: payload,
        }).then(resolveNoContent("Could not update user profile."));
    },
    patchUserProfile(userId, payload) {
        return usePromisedRequest({
            url: `/api/users/${userId}`,
            method: "PATCH",
            json: payload,
        }).then(resolveNoContent("Couldn't patch user profile."));
    },
    updateUserPreferences(userId, payload) {
        return usePromisedRequest({
            url: `/api/users/${userId}/preferences`,
            method: "PUT",
            json: payload,
        }).then(resolveNoContent("Could not update user preferences."));
    },
    getUserPreferences(userId: number): Promise<UserPreferences> {
        return usePromisedRequest<UserPreferences>({
            url: `/api/users/${userId}/preferences`,
            method: "GET",
            json: true,
        }).then(resolveWithBody("Could not get user preferences."));
    },
    completeProfile(request: CompleteProfileRequest): Promise<CompleteProfileResponse> {
        return usePromisedRequest<CompleteProfileResponse>({
            url: `/api/users/${request.userId}/complete-profile`,
            method: "post",
            json: request,
        }).then(resolveWithBody("Could not complete user profile."));
    },
    saveCompetitorOnboardingContactInfo(userId: number, contactInfo: CompetitorOnboardingContactInfo): Promise<void> {
        return usePromisedRequest({
            url: `/api/users/${userId}/competitor-onboarding/contact-info`,
            method: "post",
            json: contactInfo,
        }).then(resolveNoContent("Could not save contact information."));
    },
    deleteUserProfile(userId: number): Promise<void> {
        return usePromisedRequest({
            url: `/api/users/${userId}`,
            method: "DELETE",
        }).then(resolveNoContent("Could not delete user profile."));
    },
};
